module.exports = __webpack_public_path__ + "assets/icon-portableCornerPosts-woodenCornerPortable.0186cc7e.svg";